// Shared by the Webpacker camera intake and Sprockets office uploader.
(function (root) {
  'use strict';
  var contract = {
    imageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic', 'image/heif'],
    maxBytes: 25 * 1024 * 1024,
    failed: 'That file did not upload. Check the connection and try again.',
    tooBig: 'That file is over 25 MB. Choose a smaller one.',
    wrongKind: 'That kind of file cannot go here.',
    jpgUrl: function (file) {
      if (file && file.handle) return 'https://cdn.filestackcontent.com/output=format:jpg/' + file.handle;
      var url = file && file.url;
      var prefix = 'https://cdn.filestackcontent.com/';
      return url && url.indexOf(prefix) === 0 && url.indexOf('output=') === -1 ? prefix + 'output=format:jpg/' + url.slice(prefix.length) : url;
    },
    accepts: function (file, accept) {
      var types = accept || this.imageTypes;
      var mime = (file.type || '').toLowerCase();
      var name = (file.name || '').toLowerCase();
      if (!mime) {
        if (/\.(heic|heif)$/.test(name)) mime = 'image/heic';
        else if (/\.jpe?g$/.test(name)) mime = 'image/jpeg';
        else if (/\.png$/.test(name)) mime = 'image/png';
        else if (/\.webp$/.test(name)) mime = 'image/webp';
        else if (/\.gif$/.test(name)) mime = 'image/gif';
        else if (/\.pdf$/.test(name)) mime = 'application/pdf';
        else if (/\.(dcm|dicom)$/.test(name)) mime = 'application/dicom';
      }
      return types.some(function (type) { return type.trim() === 'image/*' ? mime.indexOf('image/') === 0 : type.trim() === mime; });
    }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = contract;
  if (root) root.TPPhotoUpload = contract;
}(typeof window !== 'undefined' ? window : null));
